import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { AddressDetails } from '../@types/ValidateZipCode'
import { FormAddressValuesProps } from '../Components/OwnerData/components/AddressForm'

type Store = {
  isValid: { [key: string]: boolean } | null
  setIsValid: (isValid: { [key: string]: boolean }, replace?: boolean) => void
  addressOwner: {
    [key: string]: FormAddressValuesProps
  } | null
  setAddressOwner: (value: {
    [key: string]: FormAddressValuesProps | null
  }) => void
  resetAddressOwner: (item: string) => void
  oldSpecies: { [key: string]: string } | null
  setOldSpecies: (value: { [key: string]: string }) => void
  deleteOldSpecies: (value: string) => void
  expandCoverageAnimal: { [key: string]: boolean } | null
  setExpandCoverageAnimal: (value: { [key: string]: boolean }) => void
  answeredList: { [key: string]: string }
  setAnsweredList: (value: { [key: string]: string }) => void
  addressZipCodeSelected: AddressDetails | null
  setAddressZipCodeSelected: (value: AddressDetails | null) => void
}

export const useAnimalValidateStore = create<Store>()(
  devtools(
    (set, get) => ({
      isValid: null,
      setIsValid: (isValid, replace = false) => {
        return set(() => {
          let newData = get().isValid

          if (replace) {
            newData = isValid
          } else {
            newData = { ...get().isValid, ...isValid }
          }

          return { isValid: newData }
        })
      },
      addressOwner: null,
      setAddressOwner: (value) => {
        return set(() => {
          let newData: any = get().addressOwner

          newData = { ...get().addressOwner, ...value }

          return { addressOwner: newData }
        })
      },
      resetAddressOwner: (item) =>
        set(() => {
          const { addressOwner } = get()

          delete addressOwner?.[item]

          return { addressOwner }
        }),
      oldSpecies: null,
      setOldSpecies: (value) => {
        set(() => {
          const newValue = { ...get().oldSpecies, ...value }

          return { oldSpecies: newValue }
        })
      },
      deleteOldSpecies: (value) => {
        set(() => {
          const { oldSpecies } = get()

          delete oldSpecies?.[value]

          return { oldSpecies }
        })
      },
      expandCoverageAnimal: null,
      setExpandCoverageAnimal: (value) => {
        set(() => {
          const newValue = { ...get().expandCoverageAnimal, ...value }

          return { expandCoverageAnimal: newValue }
        })
      },
      answeredList: {},
      setAnsweredList: (value) => {
        set(() => {
          const newValue = { ...get().answeredList, ...value }

          return { answeredList: newValue }
        })
      },
      addressZipCodeSelected: null,
      setAddressZipCodeSelected: (addressZipCodeSelected) =>
        set({ addressZipCodeSelected }),
    }),
    { name: 'AnimalValidateStore' },
  ),
)
